(function($, window, undefined) {
	function LocationsMap(args) {
		//LocationFinderMap variables
		this.deferredFitToMarkers = false;

		this.defaults = {
			selectors: {
				widgetContainer: "[data-location-finder-map-container]",
				mapContainer: "[data-location-finder-map]",
			},
		};

		this.options = $.extend(true, {}, this.defaults, args);
		this.$widgetContainer = $(this.options.selectors.widgetContainer);
		this.mapContainer = document.querySelector(this.options.selectors.mapContainer);

		if (!this.mapContainer)
            return;

		// REAL DATA,
		try {
			this.markersData = this.createMarkersData(JSON.parse(this.mapContainer.getAttribute('data-location-finder-map')));
		} catch (error) { }

		// test data
		// this.markersData = this.createMarkersData(new SVHA.Widgets.LocationsMapStaticValues().testData());

		this.map = this.createMap(this.mapContainer);

		if (Array.isArray(this.markersData)) {
			this.mapMarkers = this.createMarkers(this.map, this.markersData);
		}

		if(this.markersData.length == 1){
			this.map.setZoom(12);
			this.map.setCenter({ lat: this.markersData[0].latitude, lng: this.markersData[0].longitude });
		} else {
			let bounds = this.getBoundsCoordinatesByLayLng(this.markersData);
			this.map.fitBounds(bounds);
		}

	}

	/**
	 * Returns a jQuery element that is a child of the parent element
	 * @param selector
	 * @returns {*|HTMLElement}
	 */
	LocationsMap.prototype.parent = function(selector) {
		return $(selector, this.$widgetContainer);
	};

	LocationsMap.prototype.createMarkersData = function(ResultsJson) {

		let markersData = [];

		ResultsJson.forEach((location) => {
			let locationFeatures = "";

			location.features.forEach((feature) => {
				locationFeatures += `<p class="custom-google-map-option text-small">
									<svg class="custom-google-map-option-icon">
									<use xlink:href="/static/svg/sprite.svg#check"></use>
									</svg>
										${feature}
									</p>`;
			});

			let markerData = {
				latitude: location.latitude,
				longitude: location.longitude,
				type: location.type,
				url: location.url,
				dialogWindow:`<div class="custom-google-map-content">
								<h3 class="h4">
									<a class="custom-google-map-link" href="${location.url}">
										${location.name}
									</a>
								</h3>
								<address class="address">
									${location.address.replace(/\r\n|\r|\n/g, "<br>")}
								</address>
								${locationFeatures}
							</div>`
			};
			
			markersData.push(markerData);
		});

		return markersData
	};

	LocationsMap.prototype.createMap = function(mapContainer) {
		return new google.maps.Map(mapContainer, {
			disableDefaultUI: true,
			streetViewControl: false,
			zoom: new SVHA.Widgets.LocationsMapStaticValues().getDefaultMapOptions().defaultZoom,
			center: new SVHA.Widgets.LocationsMapStaticValues().getDefaultMapOptions().defaultCenter,
			styles: new SVHA.Widgets.LocationsMapStaticValues().getDefaultMapOptions().styles,
		});
	};

	LocationsMap.prototype.createMarkers = function(map, markersData) {
		var self = this;
		let mapMarkers = [];

		markersData.forEach((markerData) => {
			let markerIcon;
			let isHidden = false;
			switch (markerData.type) {
				case "home care":
					markerIcon = {
						url:new SVHA.Widgets.LocationsMapStaticValues().getMarkerIcon("home care"),
						anchor: new google.maps.Point(11.52, 32),
					};
					isHidden = true;
					break;
				case "aged care":
					markerIcon = {
						url: new SVHA.Widgets.LocationsMapStaticValues().getMarkerIcon("aged care"),
						anchor: new google.maps.Point(11.52, 32),
					};
					break;
				case "retirement living":
					markerIcon = {
						url:new SVHA.Widgets.LocationsMapStaticValues().getMarkerIcon("retirement living"),
						anchor: new google.maps.Point(11.52, 32),
					};
					break;
				case "dual":
					markerIcon = {
						url:new SVHA.Widgets.LocationsMapStaticValues().getMarkerIcon("dual"),
						anchor: new google.maps.Point(11.52, 32),
					};
					break;
				default:
					markerIcon = new SVHA.Widgets.LocationsMapStaticValues().getDefaultMarkerIcon();
			}

			let marker;
			if (isHidden) {
				marker = new google.maps.Marker({
					position: {
						lat: markerData.latitude,
						lng: markerData.longitude,
					},
					icon: markerIcon,
					title: markerData.title,
				});
			} else {
				marker = new google.maps.Marker({
					position: {
						lat: markerData.latitude,
						lng: markerData.longitude,
					},
					map: map,
					icon: markerIcon,
					title: markerData.title,
				});
			}

			if (markerData.dialogWindow) {
				marker.addListener("click", () => {
					let infoWindow = marker.infoWindow;
					if (!infoWindow) {
						let infoWindowContent = "";

						if (typeof markerData.dialogWindow === "function") {
							infoWindowContent = markerData.dialogWindow.call(
								self,
								markerData,
								marker
							);
						} else if (typeof markerData.dialogWindow === "string") {
							infoWindowContent = markerData.dialogWindow;
						} else {
							infoWindowContent = `<div class="c-location-map__info-window">
								<h3 class="h4">${markerData.title}</h3>
								<p>
									${marker.getPosition().lat}, ${marker.getPosition().lng}
								</p>
							</div>`;
						}

						marker.infoWindow = infoWindow = new google.maps.InfoWindow({
							content: infoWindowContent,
						});
					}

					infoWindow.open(map, marker);
				});
			}

			mapMarkers.push(marker);
		});

		return mapMarkers;
	};

	LocationsMap.prototype.getBoundsCoordinatesByLayLng = function(markersData) {
		let bounds = new google.maps.LatLngBounds();

		markersData.forEach((el) => {
			let position = new google.maps.LatLng(el.latitude, el.longitude);

			// Extend the bounds to include each repairer's position
			bounds.extend(position);
		});

		return bounds;
	}

	window.SVHA = window.SVHA || {};
	window.SVHA.Widgets = window.SVHA.Widgets || {};
	window.SVHA.Widgets.LocationsMap = LocationsMap;
})(jQuery, window);
